module.exports = __webpack_public_path__ + "img/Gruppe_Technik_und_Sicherheit.811e6601.svg";